<template>
  <div class="flex items-center">
    <div
      class="mr-2"
      style="color: rgb(130, 130, 130); font-size: 12px;"
    >
      Powered by
    </div>
    <img
      src="../assets/goers-logo.png"
      style="width: 85px; height: 24px;"
    >
  </div>
</template>
